import { render } from "./patent.vue?vue&type=template&id=5eebed67&scoped=true"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"

import "./patent.vue?vue&type=style&index=0&id=5eebed67&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eebed67"]])

export default __exports__